import moment from "moment";
import React, { useState, useEffect } from "react";
// import { LASTLOGINDETAILS } from "../../App.config";
import * as utilities from "../../utilities/utils";
import Moment from 'moment';
import swal from 'sweetalert'

const PendingApplicationComponent = (props) => {


  return (
    <>
      <div className="modal-dialog modal-dialog-centered" role="document" style={{ minHeight: "auto" }}>
        <div className="modal-content">
          <div className="modal-header">
            {/* <h5 className="modal-title" id="exampleModalLabel">
            {LASTLOGINDETAILS}
          </h5> */}
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => props.closeRemoveModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body" style={{ maxHeight: "74vh" }}>

            <span>
              <ul>
                <li className="">
                  <div className="list-group">
                    {Array.isArray(props.allPendingApplications) &&
                      props.allPendingApplications.length > 0 && props.allPendingApplications.map((app, index) => {
                        if (app.applicationType == props.applicationType) {
                          return (
                            <>
                              <div href="#" className="list-group-item custom-list-group-item list-group-item-action flex-column align-items-start">
                                <div className="d-flex w-100 justify-content-between">
                                  <div className="w-100">
                                    <strong> {app.employeeName}</strong>
                                    <small className="pl-1">(#{app.employeeNumber})</small>
                                    <small className="d-block">{Moment(app.applicationDate).format('MM-DD-YYYY HH:mm:ss')}</small>
                                    <small className="d-block">Application: <strong>#{app.employeeInformationId}</strong></small>
                                  </div>
                                  {/* <small>3 days ago</small> */}
                                  {/* <div className="button-group"> */}
                                  <button className="btn btn-sm btn-primary pl-1 pr-1 mt-1 mr-1 continue-form" onClick={() => {
                                    if (props.applicationType == "AIR")
                                      props.getAirEmployeeStatement(app.employeeInformationId)
                                    else if (props.applicationType == "STD")
                                      props.getStdEmployeeStatement(app.employeeInformationId)
                                    else if (props.applicationType == "ACMD")
                                      props.getAcmdEmployeeStatement(app.employeeInformationId)
                                    else if (props.applicationType == "CCM")
                                      props.getCCMEmployeeStatement(app.employeeInformationId)
                                  }
                                  }>Continue</button>
                                  <button className="btn btn-sm btn-danger pl-1 pr-1 mt-1" onClick={() => {
                                    return (swal({
                                      title: "Are you sure you want to discard pending application?",
                                      // text: "Once deleted, you will not be able to recover this imaginary file!",
                                      icon: "warning",
                                      buttons: true,
                                      dangerMode: true,
                                    })
                                      .then((willDelete) => {
                                        if (willDelete) {
                                          // deleteBackupUser(data);
                                          props.deleteEmployeeStatement(app.employeeInformationId, app.applicationType)
                                        } else {
                                          swal("Pending application not deleted");
                                        }
                                      }))
                                    // props.applicationType=="AIR"?props.getAirEmployeeStatement(app.employeeInformationId):props.applicationType=="STD"?props.getStdEmployeeStatement(app.employeeInformationId):props.getAcmdEmployeeStatement(app.employeeInformationId);
                                  }
                                  }>Discard</button>
                                  {/* </div> */}
                                </div>
                                <div className="d-flex w-100 justify-content-between">
                                </div>
                              </div>
                            </>
                          )
                        }
                      })
                    }
                  </div>
                </li>
              </ul>
            </span>
          </div>
        </div >
      </div >
    </>
  );
};
export default PendingApplicationComponent;
